var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"twenty"},[_c('div',{staticClass:"twenty_left"},[_c('div',{staticClass:"left_bootom"}),_c('p',[_vm._v("2020.04.18")])]),_c('div',{staticClass:"center_content"},[_c('div',{staticClass:"sphere"})]),_c('div',{staticClass:"twenty_right"},[_c('p',[_vm._v("八号地旗下的朗勤心选App苹果iOS版1.0公测版上架App Store")])])])
}]

export { render, staticRenderFns }